import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FwPlugins, { IFrame, usePluginReducer } from 'framework-plugins';
import Helmet from 'react-helmet';
import Servizi from 'enums/Servizi';
import Assistente from 'Assistente';
import { withRouter } from 'react-router';
import { setAnnoSelezionato } from '../../actions/dichiarativiActions';
import useSignalR from '../../helpers/useSignalR';
import { bindActionCreators } from '../../../node_modules/redux';
import checkServizio from '../../helpers/checkServizio';
import { trovaParametriPlugin } from './helpers';

const AssegnoUnicoUniversaleMonoanno = ({
  ufficio, annoSelezionato, impostaAnnoSelezionato, history,
}) => {
  const ANNO_RILASCIO_INIZIALE_AUU = 2022;

  usePluginReducer(() => (
    {
      CAMBIO_ANNO_AUU: (payload) => {
        if (payload.Anno !== annoSelezionato) {
          impostaAnnoSelezionato(payload.Anno);
          // Al cambio anno è necessario modificare l'URL nella barra degli indirizzi,
          // perché l'applicazione è ospitata da Dashboard e l'URL che appare deve essere quello di Dashboard
          // Utilizziamo l'URL con cancelletto "nuovo", poiché è quello noto a ISEE OL
          window.location.href = '/#/AssegnoUnicoUniversaleMonoanno/lista-dichiarazioni';
        }
      },
      ASSISTENTE_APRIPERMALINK: (payload) => {
        Assistente.apriPermalink(payload);
      },
      PULISCI_PARAMETRI_QUERY_STRING: () => {
        if (window.location.href.indexOf('?') >= 0) {
          window.location.href = '/#/AssegnoUnicoUniversaleMonoanno/lista-dichiarazioni';
        }
      },
    }));

  const { idAnagrafica, annoCampagna } = trovaParametriPlugin();
  const objSrcParam = { codiceUfficio: ufficio, idanagrafica: idAnagrafica };
  const sendMessage = useCallback((title, message) => {
    FwPlugins.postMessageToChilds(title, message);
  }, []);

  useSignalR('DichiarazioneCreata', (data) => sendMessage('DichiarazioneCreata', data));
  useSignalR('DichiarazioneStatoModificato', (data) => sendMessage('DichiarazioneStatoModificato', data));
  useSignalR('DichiarazioneModificaStatoFallita', (data) => sendMessage('DichiarazioneModificaStatoFallita', data));
  useSignalR('DichiarazioneEliminata', (data) => sendMessage('DichiarazioneEliminata', data));
  useSignalR('StampaDichiarazioneCompletata', (data) => sendMessage('StampaDichiarazioneCompletata', data));

  useEffect(() => {
    if (annoCampagna && annoCampagna !== annoSelezionato) {
      impostaAnnoSelezionato(annoCampagna);
    }
  }, [annoCampagna, annoSelezionato, impostaAnnoSelezionato]);

  // Dobbiamo impostare l'URL per l'attributo src del componente IFrame del framework plugin
  // [é  l'URL del servizio annuale da caricare]
  const urlAuuAnnoMonoanno = annoSelezionato == ANNO_RILASCIO_INIZIALE_AUU
    ? window.config.urlAssegnoUnicoUniversale
    : window.config.urlAssegnoUnicoUniversaleMonoanno
      .replace(
        '[annoADueCifre]',
        annoSelezionato.toString().slice(-2),
      );

  return (
    <React.Fragment>
      <Helmet title={`Assegno unico universale ${annoSelezionato}`} />
      <IFrame
        key={annoSelezionato}
        src={urlAuuAnnoMonoanno}
        srcParams={objSrcParam}
      />
    </React.Fragment>
  );
};

const mapStoreToProps = (store) => ({
  ufficio: store.utente.ufficioSelezionato.CodiceUfficio,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

const mapDispatchToProps = (dispatch) => ({
  impostaAnnoSelezionato: bindActionCreators(setAnnoSelezionato, dispatch),
});

AssegnoUnicoUniversaleMonoanno.propTypes = {
  ufficio: PropTypes.string.isRequired,
  impostaAnnoSelezionato: PropTypes.func,
};

export default checkServizio(Servizi.AUU)(connect(mapStoreToProps, mapDispatchToProps)(withRouter(AssegnoUnicoUniversaleMonoanno)));
